import { gql } from "@apollo/client";

export const GET_PATIENTS_QUERY = gql`
  query Patients {
    patients {
      _id
      first_name
      last_name
      gender
      birthday
    }
  }
`;

export const GET_PATIENTS_BY_FILTERING_QUERY = gql`
  query GetPatients(
    $first_name: String
    $last_name: String
    $gender: String
    $birthday: String
    $address: AddressInput
  ) {
    patientsByFiltering(
      filter: {
        first_name: $first_name
        last_name: $last_name
        gender: $gender
        birthday: $birthday
        address: $address
      }
    ) {
      _id
      first_name
      last_name
      gender
      birthday
      patient_conditions
      address {
        city
        city_code
        country
        state
        street
        street_number
      }
      spinesim_studies_ids
      additional_info
      last_access
      tenant_id
    }
  }
`;

export const GET_PATIENT_INFORMATION_BY_ID_DASHBOARD_QUERY = gql`
  query PatientById($id: String) {
    patientById(_id: $id) {
      _id
      tenant_id
      first_name
      last_name
      birthday
      age
      gender
      address {
        street
        street_number
        city
        city_code
        state
        country
      }
      nationality
      email
      studies
      spinesim_studies_ids
      pain_assessments
      weights
      heights
      patient_notes
      patient_conditions
      quality_of_life_indicators
      custom_quality_of_life_indicators
      clinical_histories
      phone
    }
  }
`;

export const GET_PATIENT_INFORMATION_BY_ID_QUERY = gql`
  query patientById($id: String) {
    patientById(_id: $id) {
      _id
      first_name
      last_name
      gender
      birthday
      weights
      heights
    }
  }
`;

export const GET_PATIENT_SPINESIM_STUDIES_IDS = gql`
  query GetPatientAndSpinSimStudies($patientId: String!) {
    patientById(_id: $patientId) {
      _id
      spinesim_studies_ids
    }
  }
`;

export const GET_PATIENT_DIGITAL_TWINS_IDS = gql`
  query GetPatientAndDigitalTwins($patientId: String!) {
    patientById(_id: $patientId) {
      _id
      digital_twins_ids
    }
  }
`;

export const GET_PATIENT_DETAILS_WITH_STUDIES_IDS_QUERY = gql`
  query patientById($id: String) {
    patientById(_id: $id) {
      _id
      first_name
      last_name
      tenant_id
      studies
    }
  }
`;
